import React from 'react';
import './component.css';

function Footer() {
  return (
    <footer>
      <p>
        &copy;
        disease.sh
      </p>
    </footer>
  );
}

export default Footer;
